const plugin = store => {
  //connect to integration
  store.dispatch("ws/connect", null, {root: true})
  store.subscribe( (mutation, state) => {
    if(mutation.type === "setUser"){
      store.dispatch("ws/subscribe", state.user.id, {root: true})
    }
  });
}
export default plugin;


// WEBPACK FOOTER //
// ./resources/assets/js/store/plugin.js